import { http } from './http'
import { Pagination, PaginationParams } from './map'
import {
  GeneratedTicket,
  GeneratedTicketList,
  GeneratedTicketPayload,
} from '../../common/models'

export interface GenerateTicketsParams extends PaginationParams {
  label?: string | null
  barcode?: string | null
  phone?: string | null
}

export const getAllGeneratedTickets = async (params?: GenerateTicketsParams) =>
  http.get<Pagination<GeneratedTicketList>>(
    `/operations/orders/onsite-orders/all`,
    { params },
  )

export const getGeneratedTicketById = async (id: string) =>
  http.get<GeneratedTicket>(`/operations/orders/onsite-order/${id}`)

export const createTicket = async (ticket: GeneratedTicketPayload) =>
  http.post<string>(`/operations/orders/generate-onsite-order`, {
    ...ticket,
  })

export interface UploadTicketsCsvResponse {
  lineNumber: number
  success: boolean
  firstName: string
  lastName: string
  email: string
  pdfLink: string
  error: string
}

export interface CreateBulkTicketPayload {
  ticketId: string
  file: File
  locale?: string
}

export const uploadTicketsCsv = async (payload: CreateBulkTicketPayload) => {
  const data = new FormData()
  data.append('file', payload.file)
  return http.post<UploadTicketsCsvResponse[]>(
    `/operations/orders/onsite-orders/generate-bulk`,
    data,
    {
      params: {
        ticketId: payload.ticketId,
        locale: payload.locale,
      },
    },
  )
}

export const getGeneratedTicketsZip = async (
  ids: string[],
  pdfType?: 'STYLED_PDF' | 'TICKETS',
) =>
  http.post<string>(`/operations/orders/onsite-orders/zip`, ids, {
    params: {
      pdfType,
    },
  })

export const getYourTicketsPdf = async (id: string) =>
  http.post<string>(`/operations/orders/onsite-order/${id}/your-tickets-pdf`)
